import { Cv, ICv, IJobRequirements } from './cv';
import { ISalary, Salary } from './salary';

export interface ICandidateJob {
  id?: any;
  other?: boolean;
  value?: string;
}

export interface ICandidate {
  additional_jobs?: any[];
  bonus_for_fill?: boolean;
  count_experience_by_seafarer?: boolean;
  current_job_years?: number;
  cv?: ICv;
  job?: ICandidateJob;
  job_experience?: any[];
  job_requirements?: IJobRequirements;
  last_update?: Date;
  position?: { other: boolean };
  rank?: any;
  salary?: ISalary;
  section?: any;
  vessel_type?: any;
  current_job_month?: number;
}

export class Candidate {
  additional_jobs: any[];
  bonus_for_fill: boolean;
  count_experience_by_seafarer: boolean;
  current_job_years: number;
  cv: Cv;
  job: ICandidateJob;
  job_experience: any[];
  last_update: Date;
  position: { other: boolean };
  rank: any;
  salary: Salary;
  section: any;
  vessel_type: any;
  current_job_month: number;

  constructor( candidate: ICandidate = {} ) {
    this.additional_jobs = candidate.additional_jobs || [];
    this.bonus_for_fill = candidate.bonus_for_fill;
    this.count_experience_by_seafarer = candidate.count_experience_by_seafarer;
    this.current_job_years = candidate.current_job_years;
    this.cv = new Cv(candidate.cv);
    this.job = candidate.job || {};
    this.job_experience = candidate.job_experience;
    this.last_update = candidate.last_update ? new Date(candidate.last_update) : null;
    this.position = candidate.position;
    this.rank = candidate.rank;
    this.salary = new Salary(candidate.salary);
    this.section = candidate.section;
    this.vessel_type = candidate.vessel_type;
    this.current_job_month = candidate.current_job_month;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/candidate.ts